import * as type from '../actions/types';

const initialState = {
  loading: false,
  data: {},
  error: false,
  errorMessage: '',
  success: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.REFUND_PENDING:
      return {
        ...state,
        loading: true,
        error: false,
        errorMessage: '',
      };
    case type.REFUND_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
      };
    case type.REFUND_FAILURE:
      return {
        ...state,
        error: true,
        errorMessage: action.payload,
        loading: false,
      };
    case type.CLEAR_REFUND:
      return {
        ...state,
        loading: false,
        data: {},
        error: false,
        errorMessage: '',
        success: false,
      };
    default:
      return state;
  }
};
